module.exports = __webpack_public_path__ + "static/media/Eyebrows_brown.12c25dcd.svg";